module.exports = __webpack_public_path__ + "static/related-content-add-link-213976a6899819c908c5275455a400e9.png";